import Heading from '@tiptap/extension-heading'

export default Heading.extend({
  addAttributes () {
    return {
      ...this.parent?.(),
      type: { default: 'heading', rendered: false }
    }
  }
})